import React from 'react';

import SumSub from '@containers/Sumsub';
import LoaderLayout from '@layouts/LoaderLayout';
import MainLayout from '@layouts/MainLayout';

import Failed from './Failed';
import InProgress from './InProgress';
import Incomplete from './Incomplete';
import Intro from './Intro';
import { useCustomContext, withCustomProvider } from './context';

export const VerifyIdentity: CustomFC = () => {
  const { isStarted, stopKYC, kycStatus, checkEnabled } = useCustomContext();

  const getContent = () => {
    if (kycStatus === 'under_review') return <InProgress />;
    if (kycStatus === 'failed') {
      if (checkEnabled) return <Incomplete />;
      return <Failed />;
    }
    return <Intro />;
  };

  return (
    <LoaderLayout isLoading={!kycStatus}>
      {!isStarted ? (
        getContent()
      ) : (
        <MainLayout backButton={stopKYC}>
          <SumSub />
        </MainLayout>
      )}
    </LoaderLayout>
  );
};

export default withCustomProvider(VerifyIdentity);
